import { Typography } from '@mui/material';
import React from 'react';
import DailyVisitors from '../../components/Reservations/ViewReservations/DailyVisitors';

const DailyVisitorsPage = () => {
    return (
        <>
            <Typography variant='h1'>Daily Visitors</Typography>
            <DailyVisitors />
        </>
    );
};

export default DailyVisitorsPage;
